import { WidgetTab } from '../common';

export const getTabToShow = (enabledTabs: WidgetTab[], currentTab: WidgetTab): WidgetTab =>
  enabledTabs.find((tab) => tab === currentTab) ?? WidgetTab.FLIGHT;
